const data = [
	{
		categoria: "Gestão de Eventos",
		icon: 'edit.svg',
		sistemas: [

			{
				url: 'http://www.uece.br/detic/',
				icon: 'book-reader',
				logo: 'anaissemanauniversitaria.png',
				nome: 'anais da semana universitária',
				descricao: "Consulta aos trabalhos apresentados na Semana Universitária da UECE. Setor responsável: Propgpq (9650)",
				corcard: 'corSExternos',
				link: 'http://semanauniversitaria.uece.br/anais'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'calendar-event',
				logo: 'eventos.png',
				nome: 'eventos',
				descricao: "Gerenciamento de todas as informações e inscrições de eventos da UECE.  Setor responsável: PROEX (9655)",
				corcard: 'corSExternos',

				link: 'http://eventos.uece.br/'
			},
			// {
			// 	url: 'http://www.uece.br/detic/',
			// 	icon: 'select-multiple',
			// 	logo: 'helios.png',
			// 	nome: 'helios',
			// 	descricao: "Helios - Sistema de Votação Online da UECE. Setor Responsável: Eleições",
			// 	corcard: 'corSExternos',
			// 	link: 'https://helios.uece.br'
			// },

			{
				url: 'http://www.uece.br/detic/',
				icon: 'school',
				logo: 'su.png',
				nome: 'semana universitária',
				descricao: "Gerenciamento de todas as informações da semana universitária da UECE. Setor responsável: Propgpq (9650)",
				corcard: 'corSExternos',
				link: 'http://semanauniversitaria.uece.br/semana/login.jsf;jsessionid=00f425536390290c34210d20043c.semanas1'
			},

		]
	},
	{
		categoria: "Gestão Acadêmica",
		icon: 'graduation-cap.svg',
		sistemas: [
			// {
			// 	url: 'http://www.uece.br/detic/',
			// 	icon: 'graduation',
			// 	logo: 'gercadv2.png',
			// 	nome: 'gercad',
			// 	descricao: "Geração de listagens com os alunos de turmas selecionadas para importação no Moodle. Setor responsável: Sate (9614)",
			// 	corcard: 'corSExternos',
			// 	link: 'http://gercad.uece.br/'
			// },
			// {
			// 	url: 'http://www.uece.br/detic/',
			// 	icon: 'graduation',
			// 	logo: 'aluno ionline.png',
			// 	nome: 'aluno online',
			// 	descricao: "Emissão de histórico, grade, situação de concludente e resultado da matrícula de alunos dos cursos de graduação. Setor responsável: Deg/Propgpq (9637-9638/9650)",
			// 	corcard: 'corSExternos',
			// 	link: 'http://alunoonline.uece.br/'
			// },
			{
				url: 'http://www.uece.br/detic/',
				icon: 'user-account',
				logo: 'ingressadmin.png',
				nome: 'ingressadmin',
				descricao: "Sistema para informar quantidade de vagas semestral para ingresso na UECE. Setor responsável: Prograd (9622)",
				corcard: 'corSExternos',
				link: 'http://ingressadmin.uece.br/ingressadmin/'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'briefcase-alt-2',
				logo: 'prof_online.png',
				nome: 'professor online',
				descricao: "Gerenciamento de frêquencias, notas de alunos e conteúdo programado de aulas dos cursos de graduação. Setor responsável: Deg (9640)",
				corcard: 'corSExternos',
				link: 'http://professoronline.uece.br/'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'book-content',
				logo: 'siduece.png',
				nome: 'siduece',
				descricao: "Gerenciamento da informação e documentação das bibliotecas da UECE. Setor responsável: Biblioteca (9685)",
				corcard: 'corSExternos',
				link: 'https://siduece.uece.br'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'slideshow',
				logo: 'sima.png',
				nome: 'sima',
				descricao: "Emissão de histórico, declarações, comprovantes e relatórios acadêmicos dos Cursos de Graduação Ead. Setor responsável: Sate (9962)",
				corcard: 'corSExternos',
				link: 'http://sima.uece.br/',
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'graduation',
				logo: 'sisacadpg.png',
				nome: 'sisacadpg',
				descricao: "Apoiar a gestão da pós-graduação da universidade. Setor responsável: Propgpq (9650)",
				corcard: 'corSExternos',
				link: 'https://sisacadpg.uece.br/'
			},

			{
				url: 'http://www.uece.br/detic/',
				icon: 'graduation',
				logo: 'sisacadpg.png',
				nome: 'sisacadg',
				descricao: "Emissão de Histórico, Declarações, Comprovantes e Relatórios Acadêmicos dos Cursos de Graduação. Setor Responsável: Prograd/DEG (9640)",
				corcard: 'corSExternos',
				link: 'https://sisacadg.uece.br/'
			},

		]
	},
	{
		categoria: "Gestão de Pessoas e Contas E-mail",
		icon: 'contact.svg',
		sistemas: [
			{
				url: 'http://www.uece.br/detic/',
				icon: 'chart',
				logo: 'avalere.png',
				nome: 'avalere',
				descricao: "Gerenciamento de processos avaliativos por meio de interface web. Setor responsável: CPA (9999)",
				corcard: 'corSExternos',
				link: 'http://avalere.uece.br/Avalere/pages/public/coletores.jsf'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'user-detail',
				logo: 'gidu.png',
				nome: 'gidu',
				descricao: "Gerenciar os dados de acesso de usuários da UECE. Setor responsável: Detic (9715)",
				corcard: 'corSExternos',
				link: 'http://gidu.uece.br/'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'pie-chart-alt-2',
				logo: 'sigad.png',
				nome: 'sigad',
				descricao: "Sigad - Sistema de Gestão de Atividades Docentes",
				corcard: 'corSExternos',
				link: 'https://sigad.uece.br'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'user-rectangle',
				logo: 'sispessoal.png',
				nome: 'sispessoal',
				descricao: "Gerenciar servidores, professores e terceirizados. Setor responsável: Degep (9727)",
				corcard: 'corSExternos',
				link: 'https://sispessoal.uece.br'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'envelope',
				logo: 'webmail.png',
				nome: 'webmail',
				descricao: "Serviços do Google para discentes, servidores e terceirizados. Setor responsável: Detic (9715)",
				corcard: 'corSExternos',
				link: 'http://webmail.uece.br/email/'
			}

		]
	},
	{
		categoria: "Gestão de Ingressantes",
		icon: 'users.svg',
		sistemas: [
			// Cards 'ingressantes ampla' e 'ingressantes cotas' removidos
			{
				url: 'http://www.uece.br/detic/',
				icon: 'user-check',
				logo: 'ingres_enem.png',
				nome: 'ingressantes enem',
				descricao: "Sistema para informar quantidade de vagas para ingresso pelo enem na UECE. Setor responsável: Prograd (9622)",
				corcard: 'corSExternos',
				link: 'https://ingressantesenem.uece.br/'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'user-plus',
				logo: 'sigma.png',
				nome: 'sigma',
				descricao: "Gerenciar o processo de Matriculas de tipo Cotas/PCD, Ampla Disputa e Enem . Setor responsável: Prograd (9650)",
				corcard: 'corSExternos',
				link: 'http://sigma.uece.br/'
			}
		]
	},
	{
		categoria: "Gestão de Bolsas",
		icon: 'book.svg',
		sistemas: [
			{
				url: 'http://www.uece.br/detic/',
				icon: 'shopping-bags',
				logo: 'bolsas.png',
				nome: 'bolsas',
				descricao: "Sistema Integrado de Gerenciamento de Bolsas da UECE. Setor responsável: Prae (9675)",
				corcard: 'corSExternos',
				link: 'http://bolsas.uece.br/'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'briefcase-alt',
				logo: 'sabes.png',
				nome: 'sabes',
				descricao: "Gerenciamento de bolsas de pesquisa Estudantis.  Setor responsável: Prograd (9622)",
				corcard: 'corSExternos',
				link: 'http://sabes.uece.br/sabes/'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'briefcase',
				logo: 'sabext.png',
				nome: 'sabext',
				descricao: "Gerenciamento de bolsas de Extensão.  Setor responsável: Proex (9655)",
				corcard: 'corSExternos',
				link: 'http://sabext.uece.br/'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'briefcase-alt-2',
				logo: 'sigbolsas.png',
				nome: 'sigbolsas',
				descricao: "Gerenciamento de bolsas de Iniciação Científica.  Setor responsável: Propgpq (9650)",
				corcard: 'corSExternos',
				link: 'http://sigbolsas.uece.br/sigbolsas/'
			},
		]
	},
	{
		categoria: "Planejamento e Orçamento",
		icon: 'book-open-check.svg',
		sistemas: [
			{
				url: 'http://www.uece.br/detic/',
				icon: 'plane-alt',
				logo: 'diariasepassagens.png',
				nome: 'diárias e passagens',
				descricao: "Solicitação e gestão de Diárias e Passagens. Setor Responsável: Proad (9701).",
				corcard: 'corSExternos',
				link: 'http://sigdp.uece.br/sigdp/paginas/login.jsf;jsessionid=00cb9890612d4d2fecc6808f58d7'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'barcode',
				logo: 'boleto.png',
				nome: 'emissão de boleto',
				descricao: "Sistema para atender o controle da arrecadação. Setor responsável: Daf (9720)",
				corcard: 'corSExternos',
				link: 'https://boleto.uece.br/boleto/main.jsf?view=br.uece.security.Usuario%40Login'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'badge-dollar',
				logo: 'financeiro.png',
				nome: 'financeiro',
				descricao: "Gerenciamento financeiro das contas da UECE. Setor responsável: Daf (9720) ",
				corcard: 'corSExternos',
				link: 'http://intranet.uece.br/sgf'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'building-house',
				logo: 'patrimonio.png',
				nome: 'patrimônio',
				descricao: "Gerenciamento dos bens patrimoniais da UECE. Setor responsável: DIMAP (9707)",
				corcard: 'corSExternos',
				link: 'http://patrimonio.uece.br/'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'bus',
				logo: 'Transportes.png',
				nome: 'transportes',
				descricao: "Apoio a Gestão de Transportes da UECE. Setor Responsável: Proad/Transportes (9741)",
				corcard: 'corSExternos',
				link: 'http://transportes.uece.br/Transportes/main.jsf?view=br.uece.transporte.LoginVO@Login'
			},
			{
				url: 'http://www.uece.br/detic/',
				icon: 'restaurant',
				logo: 'ru.png',
				nome: 'ru',
				descricao: "Sistema de gestão do Restaurante Universitário da UECE. Setor Responsável: Prae (9675)",
				corcard: 'corSExternos',
				link: 'http://ru.uece.br/'
			},
		]
	},

];

data.sort(function (a, b) {
	if (a.categoria < b.categoria) {
		return -1
	} else {
		return true;
	}
})


export default data;